import { useParams } from 'react-router-dom';

import { useChargePointFetchingContext } from 'entities/charge-point/charge-point-layout';

import { ConnectedReservesTable } from '../../../widgets/session/reserve-sessions-table/ui/connected-table';

export function ChargePointReservesPage() {
  const { chargePointName, groupId } = useParams() as {
    chargePointName: string;
    groupId: string;
  };

  const { handleSetFetchingTab } = useChargePointFetchingContext();

  return (
    <ConnectedReservesTable
      handleSetFetchingTab={handleSetFetchingTab}
      chargePointName={chargePointName}
    />
  );
}
